import { use } from 'react'

import { NotificationsContext } from '@/features/notifications/NotificationsContext'

export function useNotifications() {
  return use(NotificationsContext)
}
